var _defs, _rect, _circle, _circle2, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgN8NMovieBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    role: "img",
    "aria-label": "Movie Recommendation Automation workflow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#071629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a2440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow2",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b07bff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07bff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow2",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 18,
    floodColor: "#000",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow2",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "b"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "b",
    type: "matrix",
    values: "1 0 0 0 0                 0 1 0 0 0                 0 0 1 0 0                 0 0 0 0.65 0",
    result: "g"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "g"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("style", null, "\n      .title{font:700 48px system-ui,Segoe UI,Roboto,Arial;fill:#f1edff}\n      .sub{font:500 22px system-ui,Segoe UI,Roboto,Arial;fill:#dbcfff}\n      .label{font:700 22px system-ui,Segoe UI,Roboto,Arial;fill:#f1edff}\n      .small{font:500 18px system-ui,Segoe UI,Roboto,Arial;fill:#e6ddff}\n      .node{fill:#142a4a;stroke:#b07bff;stroke-width:2.2}\n      .chip{fill:#0f2340;stroke:#caa7ff;stroke-width:1.6}\n      .line{stroke:#caa7ff;stroke-width:3;stroke-linecap:round;opacity:.92}\n      .dot{fill:#caa7ff}\n      .muted{opacity:.75}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 210,
    r: 320,
    fill: "url(#glow2)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1220,
    cy: 740,
    r: 360,
    fill: "url(#glow2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softGlow2)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 110,
    className: "title"
  }, "Movie Recommendation Automation Bot"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 155,
    className: "sub"
  }, "n8n \" APIs \" Custom Scoring \" Gemini LLM \" Telegram"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node",
    rx: 22,
    ry: 22,
    width: 360,
    height: 170
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 52,
    className: "label"
  }, "Movie APIs"), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 92,
    className: "small muted"
  }, "Fetch latest movies"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 152,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "Trending")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 144,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "Metadata"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node",
    rx: 22,
    ry: 22,
    width: 360,
    height: 170
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 52,
    className: "label"
  }, "Filter + Score"), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 92,
    className: "small muted"
  }, "Rating \" votes \" popularity"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 168,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "Logic")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 128,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "Ranking"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node",
    rx: 22,
    ry: 22,
    width: 360,
    height: 170
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 52,
    className: "label"
  }, "Gemini Insight"), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 92,
    className: "small muted"
  }, "Summary \" vibe \" audience fit"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 178,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "LLM Summary")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214,112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 120,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 28,
    className: "small"
  }, "Mood"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M480 345 C540 345, 560 345, 620 345"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 550,
    cy: 345,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M980 345 C1040 345, 1060 345, 1120 345"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1050,
    cy: 345,
    r: 6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow2)",
    transform: "translate(520,520)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node",
    rx: 22,
    ry: 22,
    width: 560,
    height: 220
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 56,
    className: "label"
  }, "Telegram Delivery"), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 98,
    className: "small muted"
  }, "Send posters + curated picks to friends"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,124)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 186,
    height: 44
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 30,
    className: "small"
  }, "Webhook")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226,124)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 186,
    height: 44
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 30,
    className: "small"
  }, "Bot Message")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426,124)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    rx: 14,
    ry: 14,
    width: 108,
    height: 44
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 30,
    className: "small"
  }, "Poster")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,810)",
    className: "muted"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "small"
  }, "Outcome: More watching ? Less scrolling ? Zero arguments"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN8NMovieBot);
export default __webpack_public_path__ + "static/media/n8n-movie-bot.fac47f3e1980a8bc0974011741a12e9e.svg";
export { ForwardRef as ReactComponent };